/** Allowed display formats for value labels on chart marks (bars, points, etc.). */
export const CHART_LABEL_FORMATS = ['number', 'percent', 'currency'] as const;
export type ChartLabelFormat = (typeof CHART_LABEL_FORMATS)[number];

export interface BarChartCategoryAxis {
  label: string;
  categories: readonly string[];
}

export interface BarChartSeries {
  label: string;
  values: ReadonlyArray<number | null>;
}

export interface NormalizedBarChartData {
  categoryAxis: BarChartCategoryAxis;
  series: ReadonlyArray<BarChartSeries>;
  format: ChartLabelFormat;
}
